
import ListClass from './ListClass'

export default ListClass